import { cdn } from "constants/common";
import moment from "moment";
import React from "react";
const QuotationsTable = ({ item, onReject, onApprove, onView }) => {
 
 const formattedDate = moment(item?.created_at).format(
    "MMM D, YYYY HH:mm:ss"
  );

  return (
    <div className="table_responsive">
      <table className="table">
        <thead className="text-primary">
          <tr>
            <th className="col-3">Quotations</th>
            <th className="col-2">Version</th>
            <th className="col-3">Notes</th>
            <th className="col-2">Date</th>
            <th className="col-2">Actions</th>
          </tr>
        </thead>
        <tbody>
          {Array.isArray(item?.quotations) &&
            item.quotations.map((quotation, qIdx) => (
              <tr key={qIdx}>
                <td className="col-3">
                  {quotation?.pdf_path ? (
                    <a
                      href={cdn + quotation.pdf_path}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Download Quotation
                    </a>
                  ) : (
                    "N/A"
                  )}
                </td>
                <td className="col-2">{quotation?.version ?? "N/A"}</td>
                <td className="col-3">{quotation?.notes ?? ""}</td>
                <td className="col-2">
                  {quotation?.created_at
                    ? formattedDate
                    : "N/A"}
                </td>
                <td className="col-2" >
                  <div className="row_check">
                         <div className='eye_area'>
                      <div className="cursor-pointer" onClick={()=>onView(quotation?.id)} ><i class="fa-solid fa-eye"></i></div>
                    </div>
                    {(["Quote Sent", 'Quote Revised'].includes(item?.status) && qIdx === 0) && <>
                      <button className="main_button seagreen" onClick={() => onApprove(quotation?.id)}>
                        Approve
                      </button>
                      <button className="table_delete btn-sm" onClick={() => onReject(quotation?.id)}>Reject</button>
                    </>}
               
                  </div>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default QuotationsTable;
